 

<div *ngIf="!initialLoading; else loading">
<!--
<plyr-player></plyr-player>-->
<div *ngIf="stream?.publicIdentity">
<app-watch-embed (onTokenClose)="closeByToken()" [autoplay]="autoplay" [codeFromEmbed]="codeFromEmbed" *ngIf="accessOk === true"  [isEmbed]="isEmbed" [stream]="stream" ></app-watch-embed>  
<app-access-embed  (onAuth)="onAuth($event)" [sessionKey]="sessionKey"  [codeFromEmbed]="codeFromEmbed" [stream]="stream" *ngIf="accessOk === false"></app-access-embed>
</div>
<div *ngIf="!stream?.publicIdentity"><h3>404 not found</h3></div>
</div>
<ng-template #loading>
    <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;">  <app-loader></app-loader> </div>
        </div>
</ng-template>
